import { CONFLICT, UNAUTHORIZED } from 'http-status-codes';

import { removeOfferRequest, saveOfferRequest } from 'src/api/offer';
import buildReturnUrl from 'src/api/build-return-url';
import sendAddFavorites from 'src/api/add-favorites-event';
import sendRemoveFavorites from 'src/api/remove-favorites-event';
import {
  toggleLastSeenOfferFavouriteStatus,
  toggleSavedOfferFavouriteStatus
} from 'src/redux/actions/offers';
import { setError } from 'src/redux/actions/toast';

import messages from 'src/messages.json';


const toggleOfferRequest = ({ isFavourite, offerId, http }) => {
  const toggledFavourite = !isFavourite;

  const request = toggledFavourite ? saveOfferRequest({ http, offerId }) : removeOfferRequest({ http, offerId });

  toggledFavourite ? sendAddFavorites(offerId) : sendRemoveFavorites(offerId);

  return request
    .catch(error => {
      if (error.response) {
        const { status } = error.response;

        if (status === CONFLICT) {
          return true;
        }
      }
      throw error;
    })
    .then(() => [toggledFavourite])
    .catch(error => [null, error]);
};

const toggleAction = callback => ({ offerId, isFavourite }) => async (dispatch, getState, { http }) => {
  const {
    configReducer: { loginURL }
  } = getState();

  const [actualFavouriteStatus, error] = await toggleOfferRequest({
    offerId,
    isFavourite,
    http
  });

  if (!error) {
    return dispatch(
      callback({
        offerId,
        isFavourite: actualFavouriteStatus
      })
    );
  }

  if (error.response && error.response.status === UNAUTHORIZED) {
    const returnUrl = buildReturnUrl({
      originUrl: loginURL,
      returnUrl: window.location.href,
      queryParams: `&emailOriginId=Favourites&addFav=${offerId}`
    });
    return window.location.assign(returnUrl);
  }
  return dispatch(setError({ message: messages.tryAgain }));
};

// eslint-disable-next-line import/group-exports
export const toggleLastSeenOffer = toggleAction(
  toggleLastSeenOfferFavouriteStatus
);
// eslint-disable-next-line import/group-exports
export const toggleSavedOffer = toggleAction(toggleSavedOfferFavouriteStatus);

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toggleLastSeenOffer,
  toggleSavedOffer
};
